import RegistrationComplete from '../../../components/pages/users/RegistrationComplete'

export default {
  components: { RegistrationComplete }
}
